module.exports = __webpack_public_path__ + "img/my-expenses-1.9ce3c07c.svg";